<template>
  <b-modal size="xl" ref="modal" @hidden="flush" centered no-close-on-backdrop>
    <template #modal-header="{ close }">
      <h5 class="font-weight-bolder m-0">
        <span>New Company</span>
      </h5>

      <b-button
        size="sm"
        variant="none"
        class="btn-icon btn-circle btn-hover-dark"
        title="Close"
        @click="close"
        v-b-tooltip.hover
      >
        <i class="material-icons icon-xl">close</i>
      </b-button>
    </template>

    <template #default>
      <validation-observer ref="observer">
        <div
          class="alert text-center font-weight-bold"
          :class="variants"
          v-html="error || '&nbsp;'"
          v-if="error && error.length"
        />
        <div class="row">
          <div class="col-12 col-lg-4">
            <div style="margin-bottom: 1.5rem; font-size: 20px; font-weight: 600;">
              <span >Company details</span>
            </div>
            <validation-provider
              name="name"
              rules="required|max:48"
              v-slot="{ errors }"
            >
              <b-form-group label="Name *" label-for="name">
                <b-form-input :disabled="disabled" v-model="business.name" />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="display_name"
              rules="required|max:48"
              v-slot="{ errors }"
            >
              <b-form-group label="Display Name *" label-for="display_name">
                <b-form-input :disabled="disabled" v-model="business.display_name" />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="base_currency"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-group label="Currency *" label-for="base_currency">
                <currencies-dropdown
                  :disabled="disabled"
                  v-model="business.base_currency"
                />

                <b-form-text
                  text-variant="danger"
                  class="font-weight-bold"
                  v-if="errors[0]"
                  >{{ errors[0] }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="is_merchant"
              rules="required"
            >
              <b-form-group label="Is Merchant" label-for="is_merchant">
                 
                <b-form-checkbox 
                  v-model="business.is_merchant"
                  name="check-button"
                  size="lg"
                  switch
                >
                </b-form-checkbox>
              </b-form-group>
            </validation-provider>
            <validation-provider
              name="allow_integrations"
              rules="required"
            >
              <b-form-group label="Allow Integrations" label-for="allow_integrations">
                 
                <b-form-checkbox 
                  v-model="business.allow_integrations"
                  name="check-button"
                  size="lg"
                  switch
                >
                </b-form-checkbox>
              </b-form-group>
            </validation-provider>
            <validation-provider
              name="is_merchant"
              rules="required"
            >
              <b-form-group label="Bypass Buyer Signup" label-for="is_merchant">
                 
                <b-form-checkbox 
                  v-model="business.bypass_buyer_signup"
                  name="check-button"
                  size="lg"
                  switch
                >
                </b-form-checkbox>
              </b-form-group>
            </validation-provider>
            <validation-provider
              name="is_merchant"
              rules="required"
            >
              <b-form-group label="Enable accounting" label-for="is_merchant">
                 
                <b-form-checkbox 
                  v-model="business.allow_account_integrations"
                  name="check-button"
                  size="lg"
                  switch
                >
                </b-form-checkbox>
              </b-form-group>
            </validation-provider>

          </div>
          <div class="col-12 col-lg-4">
            <div style="margin-bottom: 1.5rem; font-size: 20px; font-weight: 600;">
              <span >Company admin details</span>
            </div>
            <validation-provider
              name="email"
              rules="required|email"
              v-slot="{ errors }"
            >
              <b-form-group label="Admin email *" label-for="email">
                <b-form-input
                  :disabled="disabled"
                  v-model="business.owner.email"
                />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="first_name"
              rules="required|max:48"
              v-slot="{ errors }"
            >
              <b-form-group label="Admin first name *" label-for="first_name">
                <b-form-input
                  :disabled="disabled"
                  v-model="business.owner.first_name"
                />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="last_name"
              rules="required|max:48"
              v-slot="{ errors }"
            >
              <b-form-group label="Admin last name *" label-for="last_name">
                <b-form-input
                  :disabled="disabled"
                  v-model="business.owner.last_name"
                />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="email_sender_name"
              rules="max:48"
              v-slot="{ errors }"
            >
              <b-form-group label="Email sender name *" label-for="email_sender_name">
                <b-form-input
                  :disabled="disabled"
                  v-model="business.email_sender_name"
                />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <file-drop :value.sync="business.email_header" @change-value="setAttachments"/>
          </div>
          <div class="col-12 col-lg-4">
            <div style="margin-bottom: 1.5rem; font-size: 20px; font-weight: 600;">
              <span >Telr Integration</span>
            </div>
   

            <validation-provider
              v-for="(field, index) in Object.keys(business.telr_integration.config_json)"
              v-if="field!='currency'"
              :name=field
              v-slot="{ errors }"
            >
              <b-form-group :label=labelTransform(field) :label-for="field">
                <b-form-input
                  :disabled="disabled"
                  v-model="business.telr_integration.config_json[field]"
                />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>
  
            <validation-provider
              name="is_iframe"
            >
              <b-form-group label="Seamless mode" label-for="is_iframe">
                 
                <b-form-checkbox 
                  v-model="business.telr_integration.is_iframe"
                  name="check-button"
                  size="lg"
                  switch
                >
                </b-form-checkbox>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
      </validation-observer>
    </template>

    <template #modal-footer>
      <div class="d-flex justify-content-between mx-auto">
        <b-button
          class="btn-pill font-weight-bold"
          variant="dark"
          :disabled="disabled"
          :class="{
            'spinner spinner-success spinner-lg spinner-left': sending,
          }"
          @click.stop="submit"
        >
          <span v-if="sending">Submitting...</span>
          <span v-else>Submit</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

import CompaniesService from "@/services/companies.service";
import CountriesDropdown from "@/components/countries.dropdown";
import CurrenciesDropdown from "@/components/currencies.dropdown";
import FileDrop from "@/views/pages/companies/components/FileDrop.vue";
import { formatErrorMessage } from "@/utils/random_utils";

export default {
  name: "CompanyForm",
  components: {
    ValidationObserver,
    ValidationProvider,
    CountriesDropdown,
    CurrenciesDropdown,
    FileDrop,
  },
  data() {
    return {
      error: null,
      fetching: false,
      sending: false,
      email_header_encoded: [],
      business: {
        name: null,
        display_name: null,
        country: "AE",
        is_merchant: false,
        bypass_buyer_signup: true,
        allow_account_integrations: false,
        allow_integrations: false,
        base_currency: null,
        email_header: null,
        email_sender_name: null,
        owner: {
          email: null,
          first_name: null,
          last_name: null,
        },
        telr_integration: {
          integration: 'Telr', 
          business_id: null,
          is_active: true,
          payment_methods: ["card"],
          card_schemes : ["mastercard","visa"],
          is_iframe: false,
          config_json: {
            store_id: null, 
            auth_key: null, 
            remote_api_key: null,
            currency: null,
            merchant_id: null,
            webhook_key: null,
            service_api_key: null,
            payout_account_id: null,
          }
        },
      },
    };
  },
  methods: {
    async create(payload) {
      CompaniesService.post(payload)
        .then(({ data }) => {
          this.$refs["modal"].hide();
          this.$parent.query();
        })
        .catch(({ message }) => {
          this.error = formatErrorMessage(message);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    async submit() {
      const valid = await this.$refs.observer.validate();

      if (!valid) return;

      this.error = null;
      this.sending = true;

      this.business.base_currency = this.business.base_currency["id"];
      this.business.telr_integration.config_json.currency = this.business.base_currency;
      return this.create(this.business);
    },
    show() {
      this.$refs["modal"].show();
    },
    reset() {
      if (this.$refs.observer) this.$refs.observer.reset();

      this.business = {
        name: null,
        display_name: null,
        country: "AE",
        is_merchant: false,
        allow_integrations: false,
        base_currency: null,
        email_sender_name: null,
        owner: {
          email: null,
          first_name: null,
          last_name: null,
        },
      }
    },
    flush() {
      this.fetching = false;
      this.sending = false;
      this.error = null;
      this.reset();
    },
    setAttachments(attachments) {
      let email_header_encoded = null;
      let reader;
      reader = new FileReader();
      reader.onload =  (event) => (this.business.email_header = event.target.result);
      reader.readAsDataURL(attachments[0]);
    },
    labelTransform(string){
      var i, frags = string.split('_');
      for (i=0; i<frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      } 
      return frags.join(' ');
    },

  },
  computed: {
    disabled() {
      return this.sending || this.fetching;
    },
    variants() {
      return {
        show: this.error,
        "alert-light-danger": this.error,
      };
    },
  },
};
</script>
